<template>
    <AdminPanelYoutvPackageSelling />
   </template>
   
   <script>
   import AdminPanelYoutvPackageSelling from '../components/AdminPanelYoutvPackageSelling.vue'
   export default {
       data: () => ({}),
       components: {
           AdminPanelYoutvPackageSelling
       },
       methods: {},
       mounted() {}
   }
   </script>